export default "__VITE_ASSET__BGwJjPiu__"